<template>
  <van-tag
    :color="props.link ? '#fff' : state.model?.Color"
    :text-color="props.link ? state.model?.Color : ''"
    :style="{
      fontSize: props.size + 'px',
      marginLeft: props.leftSize + 'px',
      paddingLeft: props.link ? '0' : '',
    }"
  >
    {{ state.model?.Text || "-" }}
  </van-tag>
</template>

<script>
import { onMounted, reactive } from "vue";
import constant from "@/utils/constant";

export default {
  props: {
    arrName: String,
    value: {
      type: Object,
    },
    size: {
      type: Number,
      default: 10,
    },
    leftSize: {
      type: Number,
      default: 0,
    },
    link: Boolean,
  },
  setup(props) {
    const state = reactive({
      model: {},
    });

    onMounted(() => {
      state.model = constant[props.arrName].find((w) => w.Key == props.value);
    });

    return { props, state };
  },
};
</script>
<style lang="less" scoped></style>
